import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { ShowMoreLessComponent } from "./show-more-less.component";

@NgModule({
	imports: [CommonModule, TranslateModule],
	exports: [ShowMoreLessComponent],
	declarations: [ShowMoreLessComponent],
})
export class ShowMoreLessModule {}
